import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromActions from './slice';
import { catchError, exhaustMap, map, switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { NewsService, PAGE_SIZE_FOR_CGE_NEWS } from './news.service';
import { languageChangedSuccess } from '@qvs/core/preference';
import { redirectedAfterAuthenticationSuccess, selectIsAuthenticated } from '@qvs/core/auth';
import { Store } from '@ngrx/store';
import { environment } from '#environment';
import { newsConfigurationHasChanged } from '~/modules/app/slice';

@Injectable()
export class NewsEffects {
  loadNews$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadNews),
      exhaustMap((_action) =>
        this.newsService.loadNews().pipe(
          map((items) => fromActions.loadNewsSuccess({ items })),
          catchError(() => of(fromActions.loadNewsFailure()))
        )
      )
    )
  );

  loadCgeNews$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadCgeNews),
      switchMap((action) =>
        this.newsService.loadCgeNews(action.page, action.pageSize).pipe(
          map((response) => {
            const allNewsLength = action.currentNews.length + response.items.length;
            const hasMoreCgeNewsPages = allNewsLength < response.totalItems;
            return fromActions.loadCgeNewsSuccess({
              newCgeNewsItems: response.items,
              totalItems: response.totalItems,
              hasMoreCgeNewsPages
            });
          }),
          catchError(() => of(fromActions.loadCgeNewsFailure()))
        )
      )
    )
  );

  // First batch of Cge News will be loaded here instead of NewsService.init
  resetCgeNewsOnLangChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(languageChangedSuccess, newsConfigurationHasChanged, redirectedAfterAuthenticationSuccess),
      switchMap(() =>
        this.store.select(selectIsAuthenticated).pipe(
          take(1),
          switchMap((isAuthenticated) =>
            isAuthenticated && environment?.featureFlags?.isCgeNewsEnabled
              ? [
                  fromActions.resetCgeNews(),
                  fromActions.loadCgeNews({ page: 0, pageSize: PAGE_SIZE_FOR_CGE_NEWS, currentNews: [] })
                ]
              : []
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly newsService: NewsService,
    private readonly store: Store
  ) {}
}
